import { useAppStore } from "@/stores/appStore";
import { createFileRoute } from "@tanstack/react-router";
import styled from "styled-components";
import { type_c, type_a, type_d } from "@/theme/typography";
import { useContent } from "@/hooks/useContent";
import Input from "@/components/primitives/Input/Input";
import PresetGroup from "@/components/primitives/PresetGroup/PresetGroup";
import { Modifiers } from "@/components/ui/Modifiers/Modifiers";
import { useEffect, useState } from "react";
import { contains } from "node_modules/cypress/types/jquery";
export const Route = createFileRoute("/_configurator/step-2")({
	component: Step2,
});

function Step2() {
	const { gate } = useAppStore((state) => state.configurator);
	const { getGates } = useContent();
	const gateDimensions = getGates().find((x) => x.id === gate.id)?.dimensions;
	const gateModifiers = getGates().find((x) => x.id === gate.id)?.modifiers;
	const [oldDimensions, setOldDimensions] = useState([]);
	const [linkedValue, setLinkedValue] = useState();

	const handleLinkedValues = (value) => {
		setOldDimensions(value);
	};

	//handle linked values
	useEffect(() => {
		const { center_height, outer_height } = gate.selectedDimensions;
		const currentDimensionsArray = Object.entries(gate.selectedDimensions);
		// const oldDimensionsArray = Object.entries(oldDimensions);

		// Check if the difference exceeds 60
		const isDifferenceOutOfRange = Math.abs(center_height - outer_height) > 60;

		// Check which value has been edited last and if it's increasing or decreasing
		const lastEdited = currentDimensionsArray.reduce((acc, dimension, i) => {
			if (oldDimensions.length && oldDimensions[0] === dimension[0]) {
				const isIncreasing = dimension[1] > oldDimensions[1];

				acc.push({
					isIncreasing,
					values: dimension,
				});
			}
			return acc;
		}, [])[0];

		if (isDifferenceOutOfRange && lastEdited) {
			let value;

			if (lastEdited.isIncreasing) {
				value = lastEdited.values[1] - 60 > 100 ? lastEdited.values[1] - 60 : 100;
			} else {
				value = lastEdited.values[1] + 60 > 250 ? 250 : lastEdited.values[1] + 60;
			}

			setLinkedValue({ id: lastEdited.values[0] === "center_height" ? "outer_height" : "center_height", value: value });

			useAppStore.setState((prevState) => ({
				configurator: {
					...prevState.configurator,
					["gate"]: {
						...prevState.configurator["gate"],
						["selectedDimensions"]: {
							...prevState.configurator["gate"]["selectedDimensions"],
							[lastEdited.values[0] === "center_height" ? "outer_height" : "center_height"]: value,
						},
					},
				},
			}));
		}
	}, [gate.selectedDimensions]);

	return (
		<Wrapper>
			<p className="step__number" style={type_c}>
				Step 2
			</p>
			<h4 className="step__title" style={type_a}>
				Gate Doors
			</h4>
			<div className="section_wrapper">
				<Section>
					<p className="step__subtitle" style={type_d}>
						Dimension
					</p>
					<Container>
						{gateDimensions &&
							gateDimensions.map((dimension, index) =>
								dimension.selectType === "range" ? (
									<Input
										key={index}
										title={dimension.title}
										minVal={dimension.minVal}
										maxVal={dimension.maxVal}
										step={dimension.step}
										id={dimension.id}
										defaultVal={gate.selectedDimensions[dimension.id]}
										stateType={"selectedDimensions"}
										stateKey={"gate"}
										updateLinkedValue={(value) => handleLinkedValues(value)}
										linkedValue={linkedValue}
									/>
								) : null
							)}
					</Container>
				</Section>

				<Section>
					<p className="step__subtitle" style={type_d}>
						Body
					</p>
					<Container>
						{gateDimensions &&
							gateDimensions.map((dimension, index) =>
								dimension.selectType === "preset" ? (
									<Preset key={index}>
										<p className="step__subtitle" style={type_c}>
											{dimension.title}
										</p>
										<PresetGroup
											id={dimension.id}
											items={dimension.values}
											stateType={"selectedDimensions"}
											stateKey={"gate"}
											defaultVal={gate.selectedDimensions[dimension.id]}
										/>
									</Preset>
								) : null
							)}
					</Container>
				</Section>

				{gateModifiers.length ? (
					<Section>
						<p className="step__subtitle" style={type_d}>
							Ornaments
						</p>
						<Modifiers
							modifiersArray={gateModifiers || []}
							stateKey={"gate"}
							stateType={"selectedModifiers"}
							defaultVal={gate.selectedModifiers}
						/>
					</Section>
				) : null}
			</div>
		</Wrapper>
	);
}

const Wrapper = styled.div`
	padding-block: 1rem;
	padding-inline: 10px;
	height: 100%;

	.section_wrapper {
		overflow: scroll;
		padding-bottom: 80px;
		height: 100%;
		padding-block-start: 0.5rem;
	}

	& > :last-child {
		margin-bottom: 0;
	}

	.step__number {
		color: #7d6a64;
	}

	.step__title {
		padding-block-end: 0.5rem;
		color: ${({ theme }) => theme.colors.secondary};
	}

	.step__subtitle {
		margin-bottom: 0.3rem;
		font-weight: 400;
		color: #7d6a64;
		margin-bottom: 0.5rem;
	}
`;

const Section = styled.section`
	margin-bottom: 1.5rem;
`;

const Preset = styled.section`
	margin-bottom: 0.5rem;
`;

const Container = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 1rem;
	background: #e9e1de;
	padding-inline: 16px;
	padding-block: 1rem;
	border-radius: 5px;
`;
